"use client";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import Link from "next/link";
import Fb from "@/public/icon/fb.svg";
import X from "@/public/icon/tw.svg";
import In from "@/public/icon/in.svg";
import Tg from "@/public/icon/tg.svg";
import Wp from "@/public/icon/wp.svg";
import Copy from "@/public/icon/copy.svg";
const Share = ({ t }) => {
  const [active, setActive] = useState(false);
  const pathname = usePathname();
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(`${window.location.origin}${pathname}`);
    }
  }, [pathname]);

  const shareOnFacebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    currentUrl
  )}`;
  const shareOnLinkedIn = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    currentUrl
  )}`;
  const shareOnTwitter = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    currentUrl
  )}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {});
    setActive(!active);
    setTimeout(() => {
      setActive(active);
    }, 1200);
  };
  return (
    <div className="share">
      <span>{t["frontend.share_items"]}:</span>
      <a href={shareOnFacebook} target="_blank" rel="noopener noreferrer">
        <Fb />
      </a>
      <a href={shareOnTwitter} target="_blank" rel="noopener noreferrer">
        <X />
      </a>
      <a href={shareOnLinkedIn} target="_blank" rel="noopener noreferrer">
        <In />
      </a>
      <div className="copiedClass">
        {active && <div className="copied">{t["message.copied"]}!</div>}
        <button type="button" onClick={copyToClipboard}>
          <Copy />
        </button>
      </div>
    </div>
  );
};

export default Share;
